// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__xBahT","mobileIcon":"Navbar_mobileIcon__UVU7P","signInButton":"Navbar_signInButton__AVObX","navLinks":"Navbar_navLinks__6qiib"};